import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { autoMap, AutoMapperLogger, createMap, forMember, mapFrom, mapWith, typeConverter, } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";
import { CommonEnumData, CommonFilterModel } from "src/app/infrastructure/infrastructure-services/common/models/wrapper.model";

/////////////////Document Lines Model/////////////

export interface IDocumentLinesModel {
    docEntry: number;
    lineNum: number;
    lineVendor: string;
    lineVendorName: string
    itemCode: string;
    baseLine?: string | number
    itemDescription: string;
    baseEntry?: string | number;
    quantity: number;
    shipDate: string | Date;
    price: number;
    unitPrice: number;
    priceAfterVAT: number;
    discountPercent: number;
    warehouseCode: string;
    wareHouseName?: string;
    accountCode: string;
    accountName: string;
    projectCode: string;
    projectName: string;
    locationCode: number;
    locationName: string;
    uoMEntry: number;
    uoMCode: string;

    ocrCode: string;
    ocrName: string;

    taxTotal: number;
    lineTotal: number;
    taxCode: string;
    taxName: string;
    openAmount: number;
    lineStatus: string;
    taxRate: number;
    gstRelevnt: string
    baseType?: number | string;
    baseRef?: string | number;
    trgetEntry: number;
    targetType: number;
    sacEntry: string;
    hsnEntry: string;
    requriedDate: string | Date
    hsnDescription: string;
    chapterID: string;
    warehouseQuantity: string;
    openCreQty: number;
    openQty: number;
    manageBatchNumbers: string;
    manageSerialNumbers: string;
    serialNumbers: ISerialNumbersModel[],
    batchNumbers: BatchNumbersModel[],
    docNum: number;
    documentAdditionalExpenses_DocLine: any
    objType: any
    u_MPIN?: string;
}
export interface IBatchNumbersModel {
    batchNumber: string,
    manufacturerSerialNumber: string | null,
    internalSerialNumber: string | null,
    expiryDate: string,
    manufacturingDate: string,
    addmisionDate: string,
    notes: string,
    quantity: number,
    baseLineNumber: number,
    itemCode: string,
    systemSerialNumber: number
}

export interface ISerialNumbersModel {
    manufacturerSerialNumber: string | null,
    internalSerialNumber: string | null,
    expiryDate: string,
    manufactureDate: string,
    receptionDate: string,
    baseLineNumber: number,
    //  systemSerialNumber: number,
    quantity: number,
    itemCode: string,
    wareHouseCode: string,
    wareHouseName: string
}
export class BatchNumbersModel implements IBatchNumbersModel {
    @AutoMap() batchNumber: string = "";
    @AutoMap() manufacturerSerialNumber: string | null = null;
    @AutoMap() internalSerialNumber: string | null = null;
    @AutoMap() expiryDate: string = "";
    @AutoMap() manufacturingDate: string = "";
    @AutoMap() addmisionDate: string = "";
    @AutoMap() notes: string = "";
    @AutoMap() quantity: number = 0;
    @AutoMap() baseLineNumber: number = 0;
    @AutoMap() itemCode: string = "";
    @AutoMap() systemSerialNumber: number = 0;
    @AutoMap() batchNumberProperty: string = ''

    constructor() {
        createMap(mapper, BatchNumbersModel, BatchNumbersModelSAP,
            forMember(
                (destination) => (destination.BatchNumber),
                mapFrom((source) => (source.batchNumber))
            ),
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.BatchNumberProperty),
                mapFrom((source) => (source.batchNumberProperty))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufacturingDate),
                mapFrom((source) => (source.manufacturingDate))
            ),
            forMember(
                (destination) => (destination.AddmisionDate),
                mapFrom((source) => (source.addmisionDate))
            ),
            forMember(
                (destination) => (destination.Notes),
                mapFrom((source) => (source.notes))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            // forMember(
            //     (destination) => (destination.BaseLineNumber),
            //     mapFrom((source) => (source.baseLineNumber))
            // ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            )
            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),

        );
    }
}

export interface IBatchNumbersModelSAP {
    BatchNumber: string,
    ManufacturerSerialNumber: string | null,
    InternalSerialNumber: string | null,
    ExpiryDate: string,
    ManufacturingDate: string,
    AddmisionDate: string,
    Notes: string,
    Quantity: number,
    // BaseLineNumber: number,
    ItemCode: string,
    // SystemSerialNumber: number
    // SysNumber:string
    BatchNumberProperty: string

}

export class BatchNumbersModelSAP implements IBatchNumbersModelSAP {
    @AutoMap() BatchNumber: string = "";
    @AutoMap() ManufacturerSerialNumber: string | null = null;
    @AutoMap() InternalSerialNumber: string | null = null;
    @AutoMap() ExpiryDate: string = "";
    @AutoMap() ManufacturingDate: string = "";
    @AutoMap() AddmisionDate: string = "";
    @AutoMap() Notes: string = "";
    @AutoMap() Quantity: number = 0;
    // @AutoMap() BaseLineNumber: number = 0;
    @AutoMap() ItemCode: string = "";
    //  @AutoMap() SystemSerialNumber: number = 19;
    //@AutoMap() SystemSerialNumber:   string="abc";
    @AutoMap() BatchNumberProperty: string = ''
    // @AutoMap() SysNumber:string="abc";

    constructor() {
        createMap(mapper, BatchNumbersModel, BatchNumbersModelSAP,
            forMember(
                (destination) => (destination.BatchNumber),
                mapFrom((source) => (source.batchNumber))
            ),
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufacturingDate),
                mapFrom((source) => (source.manufacturingDate))
            ),
            forMember(
                (destination) => (destination.AddmisionDate),
                mapFrom((source) => (source.addmisionDate))
            ),
            forMember(
                (destination) => (destination.Notes),
                mapFrom((source) => (source.notes))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            // forMember(
            //     (destination) => (destination.BaseLineNumber),
            //     mapFrom((source) => (source.baseLineNumber))
            // ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.BatchNumberProperty),
                mapFrom((source) => (source.batchNumberProperty))
            ),

            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),

        );
    }
}

export class SerialNumbersModel implements ISerialNumbersModel {

    @AutoMap() manufacturerSerialNumber: string | null = null;
    @AutoMap() internalSerialNumber: string | null = null;
    @AutoMap() expiryDate: string = "";
    @AutoMap() manufactureDate: string = "";
    @AutoMap() receptionDate: string = "";
    @AutoMap() baseLineNumber: number = 0;
    //@AutoMap() systemSerialNumber: number = 0;
    @AutoMap() quantity: number = 0;
    @AutoMap() itemCode: string = "";
    @AutoMap() wareHouseCode: string = "";
    @AutoMap() wareHouseName: string = "";
    constructor() {
        createMap(mapper, SerialNumbersModel, SerialNumbersModelSAP,
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufactureDate),
                mapFrom((source) => (source.manufactureDate))
            ),
            forMember(
                (destination) => (destination.ReceptionDate),
                mapFrom((source) => (source.receptionDate))
            ),
            forMember(
                (destination) => (destination.BaseLineNumber),
                mapFrom((source) => (source.baseLineNumber))
            ),
            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.WareHouseCode),
                mapFrom((source) => (source.wareHouseCode))
            ),
            forMember(
                (destination) => (destination.WareHouseName),
                mapFrom((source) => (source.wareHouseName))
            ),
        );
    }
}

export interface ISerialNumbersModelSAP {
    ManufacturerSerialNumber: string,
    InternalSerialNumber: string,
    ExpiryDate: string,
    ManufactureDate: string,
    ReceptionDate: string,
    BaseLineNumber: number,
    // SystemSerialNumber: number,
    Quantity: number,
    ItemCode: string,
    WareHouseCode: string,
    WareHouseName: string

}

export class SerialNumbersModelSAP implements ISerialNumbersModelSAP {
    @AutoMap() ManufacturerSerialNumber: string = "";
    @AutoMap() InternalSerialNumber: string = "";
    @AutoMap() ExpiryDate: string = "";
    @AutoMap() ManufactureDate: string = "";
    @AutoMap() ReceptionDate: string = "";
    @AutoMap() BaseLineNumber: number = 0;
    //  @AutoMap() SystemSerialNumber: number = 0;
    @AutoMap() Quantity: number = 0;
    @AutoMap() ItemCode: string = "";
    @AutoMap() WareHouseCode: string = "";
    @AutoMap() WareHouseName: string = "";

    constructor() {
        createMap(mapper, SerialNumbersModel, SerialNumbersModelSAP,
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufactureDate),
                mapFrom((source) => (source.manufactureDate))
            ),
            forMember(
                (destination) => (destination.ReceptionDate),
                mapFrom((source) => (source.receptionDate))
            ),
            forMember(
                (destination) => (destination.BaseLineNumber),
                mapFrom((source) => (source.baseLineNumber))
            ),
            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.WareHouseCode),
                mapFrom((source) => (source.wareHouseCode))
            ),
            forMember(
                (destination) => (destination.WareHouseName),
                mapFrom((source) => (source.wareHouseName))
            ),
        );
    }
}
export interface IDocumentLinesModelSAP {
    ItemCode: string,
    ItemDescription: string,
    BarCode: string,
    Quantity: number,
    //  MeasureUnit: string,
    UnitPrice: number,
    TaxCode: string,
    LineTotal: number,
    WarehouseCode: string,
    //WarehouseName: string,
    WarehouseQuantity: number,
    //  AccountCode: string,
    // AccountName:string,
    ProjectCode: string,
    // ProjectName:string
    SerialNumbers: SerialNumbersModelSAP[],
    BatchNumbers: BatchNumbersModelSAP[],
    U_MPIN?: string,
}
export class DocumentLinesModel implements IDocumentLinesModel {
    @AutoMap() docNum: number = 0;
    @AutoMap() docEntry!: number;
    @AutoMap() lineNum!: number;
    @AutoMap() baseLine: string | number = '';
    @AutoMap() baseEntry: string | number = ''
    @AutoMap() lineVendor: string = '';
    @AutoMap() lineVendorName: string = '';
    @AutoMap() itemCode: string = "";
    @AutoMap() objType: string = "";
    @AutoMap() itemDescription: string = "";
    @AutoMap() quantity: number = 0;
    @AutoMap() shipDate: string | Date = "";
    @AutoMap() price!: number;
    @AutoMap() unitPrice!: number;
    @AutoMap() priceAfterVAT!: number;
    @AutoMap() discountPercent: number = 0;
    @AutoMap() warehouseCode: string = "";
    @AutoMap() documentAdditionalExpenses_DocLine: string = "";
    @AutoMap() wareHouseName?: string = "";
    @AutoMap() accountCode: string = "";
    @AutoMap() accountName: string = "";
    @AutoMap() projectCode: string = "";
    @AutoMap() projectName: string = "";
    @AutoMap() locationCode!: number;
    @AutoMap() locationName: string = "";
    @AutoMap() uoMEntry!: number;
    @AutoMap() uoMCode: string = "";
    @AutoMap() taxTotal!: number;
    @AutoMap() lineTotal!: number;
    @AutoMap() taxCode: string = "";
    @AutoMap() taxName: string = "";
    @AutoMap() openAmount!: number;
    @AutoMap() lineStatus: string = "";
    @AutoMap() gstRelevnt: string = ""

    @AutoMap() taxRate: number = 0
    @AutoMap() baseType!: number | string;
    @AutoMap() baseRef: string | number = "";
    @AutoMap() trgetEntry!: number;
    @AutoMap() targetType!: number;
    @AutoMap() sacEntry: string = "";
    @AutoMap() hsnEntry: string = "";
    @AutoMap() requriedDate: string | Date = "";
    @AutoMap() hsnDescription: string = "";
    @AutoMap() chapterID: string = "";
    @AutoMap() warehouseQuantity: string = "";
    @AutoMap() openCreQty!: number;
    @AutoMap() openQty!: number;
    @AutoMap() manageBatchNumbers: string = "";
    @AutoMap() manageSerialNumbers: string = "";
    @AutoMap() serialNumbers: SerialNumbersModel[] = [];
    @AutoMap() batchNumbers: BatchNumbersModel[] = [];
    @AutoMap() ocrCode: string = "";
    @AutoMap() ocrName: string = "";

    @AutoMap() u_MPIN?: string = "";
    constructor() {
        createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
            forMember(
                (destination) => destination.GstRelevnt,
                mapFrom((source) => source.gstRelevnt)
            ),
            forMember(
                (destination) => destination.LineNum,
                mapFrom((source) => source.lineNum == null ? undefined : source.lineNum)
            ),
            forMember(
                (destination) => destination.ItemCode,
                mapFrom((source) => source.itemCode)
            ),

            forMember(
                (destination) => destination.LineVendor,
                mapFrom((source) => source.lineVendor)
            ),

            forMember(
                (destination) => destination.ItemDescription,
                mapFrom((source) => source.itemDescription)
            ),
            forMember(
                (destination) => destination.Quantity,
                mapFrom((source) => source.quantity)
            ),
            forMember(
                (destination) => destination.ShipDate,
                mapFrom((source) => source.shipDate)
            ),
            forMember(
                (destination) => destination.Price,
                mapFrom((source) => source.price)
            ),
            forMember(
                (destination) => destination.UnitPrice,
                mapFrom((source) => source.unitPrice)
            ),
            forMember(
                (destination) => destination.PriceAfterVAT,
                mapFrom((source) => source.priceAfterVAT)
            ),
            forMember(
                (destination) => destination.DiscountPercent,
                mapFrom((source) => source.discountPercent)
            ),
            forMember(
                (destination) => destination.WarehouseCode,
                mapFrom((source) => source.warehouseCode)
            ),

            forMember(
                (destination) => destination.AccountCode,
                mapFrom((source) => source.accountCode)
            ),
            forMember(
                (destination) => destination.AccountName,
                mapFrom((source) => source.accountName)
            ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.ProjectName,
                mapFrom((source) => source.projectName)
            ),
            forMember(
                (destination) => destination.LocationCode,
                mapFrom((source) => source.locationCode)
            ),

            forMember(
                (destination) => destination.UoMCode,
                mapFrom((source) => source.uoMCode)
            ),
            forMember(
                (destination) => destination.UoMEntry,
                mapFrom((source) => source.uoMEntry)
            ),
            forMember(
                (destination) => destination.TaxTotal,
                mapFrom((source) => source.taxTotal)
            ),
            // forMember(
            //     (destination) => destination.LineTotal,
            //     mapFrom((source) => source.lineTotal)
            // ),
            forMember(
                (destination) => destination.TaxCode,
                mapFrom((source) => source.taxCode)
            ),
            forMember(
                (destination) => destination.OpenAmount,
                mapFrom((source) => source.openAmount)
            ),

            forMember(
                (destination) => destination.LineStatus,
                mapFrom((source) => source.lineStatus)
            ),
            forMember(
                (destination) => destination.BaseLine,
                mapFrom((source) => source.baseLine)
            ),
            forMember(
                (destination) => destination.BaseEntry,
                mapFrom((source) => source.baseEntry)
            ),
            forMember(
                (destination) => destination.BaseType,
                mapFrom((source) => source.baseType)
            ),
            forMember(
                (destination) => destination.BaseRef,
                mapFrom((source) => source.baseRef)
            ),
            forMember(
                (destination) => destination.TrgetEntry,
                mapFrom((source) => source.trgetEntry)
            ),

            forMember(
                (destination) => destination.TargetType,
                mapFrom((source) => source.targetType)
            ),
            forMember(
                (destination) => destination.SacEntry,
                mapFrom((source) => source.sacEntry)
            ),
            forMember(
                (destination) => destination.HSNEntry,
                mapFrom((source) => source.hsnEntry)
            ),
            forMember(
                (destination) => destination.RemainingOpenQuantity,
                mapFrom((source) => source.openCreQty)
            ),
            forMember(
                (destination) => destination.RemainingOpenQuantity,
                mapFrom((source) => source.openCreQty)
            ),
            forMember(
                (destination) => destination.RemainingOpenQuantity,
                mapFrom((source) => source.openCreQty)
            ),
            forMember(
                (destination) => destination.ManageBatchNumbers,
                mapFrom((source) => source.manageBatchNumbers)
            ),
            forMember(
                (destination) => destination.ManageSerialNumbers,
                mapFrom((source) => source.manageSerialNumbers)
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            ),
            forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
            ),
            forMember(
                (destination) => destination.CostingCode,
                mapFrom((source) => source.ocrCode)
            ),
            forMember(
                (destination) => destination.OcrName,
                mapFrom((source) => source.ocrName)
            ),
            forMember(
                (destination) => destination.U_MPIN,
                mapFrom((source) => source.u_MPIN)),

        );
    }
}
// export interface IDocumentLinesModelSAP {
//     DocEntry: number;
//     LineNum: number;
//     LineVendor: string;

//     ItemCode: string;
//     ItemDescription: string;
//     Quantity: number;
//     ShipDate: string | null;
//     Price: number;
//     UnitPrice: number;
//     PriceAfterVAT: number;
//     DiscountPercent: number;
//     WarehouseCode: string;
//     GstRelevnt: string
//     // WareHouseName?: string;
//     AccountCode: string;
//     AccountName: string;
//     ProjectCode: string;
//     ProjectName: string;
//     LocationCode: number;
//     UoMEntry: number;
//     UoMCode: string;
//     TaxTotal: number;
//     LineTotal: number;
//     TaxCode: string;
//     OpenAmount: number;
//     LineStatus: string;
//     // BaseLine: number;
//     //  BaseEntry: number;
//     BaseType: number;
//     BaseRef: string;
//     TrgetEntry: number;
//     TargetType: number;
//     SacEntry: string;
//     HSNEntry: string;
//     RemainingOpenQuantity: number;
//     ManageBatchNumbers: string;
//     ManageSerialNumbers: string;
//     SerialNumbers: SerialNumbersModelSAP[];
//     BatchNumbers: BatchNumbersModelSAP[];
//     // requriedDate:string;
// }
export class DocumentLinesModelSAP implements IDocumentLinesModelSAP {
    @AutoMap() DocEntry!: number;
    @AutoMap() LineNum!: number;
    @AutoMap() LineVendor: string = '';
    @AutoMap() BarCode: string = "";
    @AutoMap() WarehouseQuantity: number = 0;
    @AutoMap() ItemCode: string = "";
    @AutoMap() ItemDescription: string = "";
    @AutoMap() Quantity: number = 0;
    @AutoMap() ShipDate: string | null = null;
    @AutoMap() Price!: number;
    @AutoMap() UnitPrice!: number;
    @AutoMap() PriceAfterVAT!: number;
    @AutoMap() DiscountPercent!: number;
    @AutoMap() WarehouseCode: string = "";

    @AutoMap() GstRelevnt: string = "";
    @AutoMap() AccountCode: string = "";
    @AutoMap() AccountName: string = "";
    @AutoMap() ProjectCode: string = "";
    @AutoMap() ProjectName: string = "";
    @AutoMap() LocationCode!: number;
    @AutoMap() UoMEntry!: number;
    @AutoMap() UoMCode: string = "";
    @AutoMap() TaxTotal!: number;
    @AutoMap() LineTotal!: number;
    @AutoMap() TaxCode: string = "";
    @AutoMap() OpenAmount!: number;
    @AutoMap() LineStatus: string = "";
    @AutoMap() BaseLine!: number;
    @AutoMap() BaseEntry!: number;
    @AutoMap() BaseType!: number;
    @AutoMap() BaseRef: string = "";

    @AutoMap() TrgetEntry!: number;
    @AutoMap() TargetType!: number;
    @AutoMap() SacEntry: string = "";
    @AutoMap() HSNEntry: string = "";
    @AutoMap() RemainingOpenQuantity!: number;
    @AutoMap() ManageBatchNumbers: string = "";
    @AutoMap() ManageSerialNumbers: string = "";
    @AutoMap() SerialNumbers: SerialNumbersModelSAP[] = [];
    @AutoMap() BatchNumbers: BatchNumbersModelSAP[] = [];
    @AutoMap() CostingCode: string = "";
    @AutoMap() OcrName: string = "";
    @AutoMap() U_MPIN?: string = "";
    constructor() {
        createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
            forMember(
                (destination) => destination.DocEntry,
                mapFrom((source) => source.docEntry)
            ),
            forMember(
                (destination) => destination.LineVendor,
                mapFrom((source) => source.lineVendor)
            ),
            forMember(
                (destination) => destination.GstRelevnt,
                mapFrom((source) => source.gstRelevnt)
            ),
            forMember(
                (destination) => destination.LineNum,
                mapFrom((source) => source.lineNum == null ? undefined : source.lineNum)
            ),
            forMember(
                (destination) => destination.ItemCode,
                mapFrom((source) => source.itemCode)
            ),
            forMember(
                (destination) => destination.ItemDescription,
                mapFrom((source) => source.itemDescription)
            ),

            forMember(
                (destination) => destination.Quantity,
                mapFrom((source) => source.quantity)
            ),
            forMember(
                (destination) => destination.ShipDate,
                mapFrom((source) => source.shipDate)
            ),
            forMember(
                (destination) => destination.Price,
                mapFrom((source) => source.price)
            ),
            forMember(
                (destination) => destination.UnitPrice,
                mapFrom((source) => source.unitPrice)
            ),
            forMember(
                (destination) => destination.PriceAfterVAT,
                mapFrom((source) => source.priceAfterVAT)
            ),
            forMember(
                (destination) => destination.DiscountPercent,
                mapFrom((source) => source.discountPercent)
            ),
            forMember(
                (destination) => destination.WarehouseCode,
                mapFrom((source) => source.warehouseCode)
            ),

            forMember(
                (destination) => destination.AccountCode,
                mapFrom((source) => source.accountCode)
            ),
            forMember(
                (destination) => destination.AccountName,
                mapFrom((source) => source.accountName)
            ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.ProjectName,
                mapFrom((source) => source.projectName)
            ),
            forMember(
                (destination) => destination.LocationCode,
                mapFrom((source) => source.locationCode)
            ),

            forMember(
                (destination) => destination.UoMEntry,
                mapFrom((source) => source.uoMEntry)
            ),
            forMember(
                (destination) => destination.UoMCode,
                mapFrom((source) => source.uoMCode)
            ),
            forMember(
                (destination) => destination.TaxTotal,
                mapFrom((source) => source.taxTotal)
            ),
            // forMember(
            //     (destination) => destination.LineTotal,
            //     mapFrom((source) => source.lineTotal)
            // ),
            forMember(
                (destination) => destination.TaxCode,
                mapFrom((source) => source.taxCode)
            ),
            forMember(
                (destination) => destination.OpenAmount,
                mapFrom((source) => source.openAmount)
            ),

            forMember(
                (destination) => destination.LineStatus,
                mapFrom((source) => source.lineStatus)
            ),
            forMember(
                (destination) => destination.BaseLine,
                mapFrom((source) => source.baseLine)
            ),
            forMember(
                (destination) => destination.BaseEntry,
                mapFrom((source) => source.baseEntry)
            ),
            forMember(
                (destination) => destination.BaseType,
                mapFrom((source) => source.baseType)
            ),
            forMember(
                (destination) => destination.BaseRef,
                mapFrom((source) => source.baseRef)
            ),
            forMember(
                (destination) => destination.TrgetEntry,
                mapFrom((source) => source.trgetEntry)
            ),
            forMember(
                (destination) => destination.TargetType,
                mapFrom((source) => source.targetType)
            ),
            forMember(
                (destination) => destination.SacEntry,
                mapFrom((source) => source.sacEntry)
            ),
            forMember(
                (destination) => destination.HSNEntry,
                mapFrom((source) => source.hsnEntry)
            ),
            forMember(
                (destination) => destination.RemainingOpenQuantity,
                mapFrom((source) => source.openCreQty)
            ),
            forMember(
                (destination) => destination.ManageBatchNumbers,
                mapFrom((source) => source.manageBatchNumbers)
            ),
            forMember(
                (destination) => destination.ManageSerialNumbers,
                mapFrom((source) => source.manageSerialNumbers)
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            ), forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
            ),
            forMember(
                (destination) => destination.CostingCode,
                mapFrom((source) => source.ocrCode)
            ),
            forMember(
                (destination) => destination.OcrName,
                mapFrom((source) => source.ocrName)

            ),
            forMember((destination) => destination.U_MPIN,
                mapFrom((source) => source.u_MPIN),
            )
            // forMember(
            //     (destination) => destination.requriedDate,
            //     mapFrom((source) => source.requriedDate="2023-04-10T00:00:00Z")
            // )
        );
    }
}
/////////////////////////////End////////////////////////

///////////////Frieght Model/////////////////////////////
export interface IDocumentAdditionalExpensesModel {
    // docEntry: number;
    //   lineNum: number;
    expenseCode: number;
    //   expenseName: string;
    lineTotal: number;
    distributionMethod: string;
    taxSum: number;
    taxPercent: number;
    taxCode: string;
    lineGross: number;
    remarks: string


}
export class DocumentAdditionalExpensesModel implements IDocumentAdditionalExpensesModel {
    // @AutoMap() docEntry: number = 0;
    //  @AutoMap() lineNum: number = 0;
    @AutoMap() expenseCode: number = 0;
    //  @AutoMap() expenseName: string = "";
    @AutoMap() lineTotal: number = 0;
    @AutoMap() distributionMethod: string = "";
    @AutoMap() taxSum: number = 0;
    @AutoMap() taxPercent: number = 0;
    @AutoMap() taxCode: string = "";
    @AutoMap() lineGross: number = 0;
    @AutoMap() remarks: string = ""
    constructor() {
        createMap(mapper, DocumentAdditionalExpensesModel, DocumentAdditionalExpensesModelSAP,
            // forMember(
            //     (destination) => destination.DocEntry,
            //     mapFrom((source) => source.docEntry)
            // ),
            // forMember(
            //     (destination) => destination.LineNum,
            //     mapFrom((source) => source.lineNum == null ? undefined : source.lineNum)
            // ),
            forMember(
                (destination) => destination.ExpenseCode,
                mapFrom((source) => source.expenseCode)
                // mapFrom((source) => source.expenseCode = 4)
            ),
            // forMember(
            //     (destination) => destination.ExpenseName,
            //     mapFrom((source) => source.expenseName)
            // ),
            forMember(
                (destination) => destination.LineTotal,
                mapFrom((source) => source.lineTotal)
            ),
            forMember(
                (destination) => destination.DistributionMethod,
                mapFrom((source) => source.distributionMethod)
            ),
            forMember(
                (destination) => destination.TaxSum,
                mapFrom((source) => source.taxSum)
            ),
            forMember(
                (destination) => destination.TaxPercent,
                mapFrom((source) => source.taxPercent)
            ),
            forMember(
                (destination) => destination.TaxCode,
                mapFrom((source) => source.taxCode)
            ),
            forMember(
                (destination) => destination.LineGross,
                mapFrom((source) => source.lineGross)
            )
        );
    }
}

export interface IDocumentAdditionalExpensesModelSAP {
    //  DocEntry: number;
    LineNum: number;
    ExpenseCode: number;
    //   ExpenseName: string;
    LineTotal: number;
    DistributionMethod: string;
    TaxSum: number;
    TaxPercent: number;
    TaxCode: string;
    LineGross: number;
}

export class DocumentAdditionalExpensesModelSAP implements IDocumentAdditionalExpensesModelSAP {
    // @AutoMap() DocEntry!: number;
    @AutoMap() LineNum!: number;
    @AutoMap() ExpenseCode!: number;
    //  @AutoMap() ExpenseName: string = "";
    @AutoMap() LineTotal!: number;
    @AutoMap() DistributionMethod: string = "";
    @AutoMap() TaxSum!: number;
    @AutoMap() TaxPercent!: number;
    @AutoMap() TaxCode: string = "";
    @AutoMap() LineGross!: number;
    constructor() {
        createMap(mapper, DocumentAdditionalExpensesModel, DocumentAdditionalExpensesModelSAP,
            // forMember(
            //     (destination) => destination.DocEntry,
            //     mapFrom((source) => source.docEntry)
            // // ),
            // forMember(
            //     (destination) => destination.LineNum,
            //     mapFrom((source) => source.lineNum == null ? undefined : source.lineNum)
            // ),
            forMember(
                (destination) => destination.ExpenseCode,
                mapFrom((source) => source.expenseCode)
                // mapFrom((source) => source.expenseCode = 4)
            ),
            forMember(
                (destination) => destination.LineTotal,
                mapFrom((source) => source.lineTotal)
            ),
            forMember(
                (destination) => destination.DistributionMethod,
                mapFrom((source) => source.distributionMethod)
            ),
            forMember(
                (destination) => destination.TaxSum,
                mapFrom((source) => source.taxSum)
            ),
            forMember(
                (destination) => destination.TaxPercent,
                mapFrom((source) => source.taxPercent)
            ),
            forMember(
                (destination) => destination.TaxCode,
                mapFrom((source) => source.taxCode)
            ),
            forMember(
                (destination) => destination.LineGross,
                mapFrom((source) => source.lineGross)
            )
        );
    }
}
/////////////////////////////End////////////////////////

///////////////Tax Extension Model/////////////////////////////
export interface ITaxExtensionModel {
    docEntry: number;
    importOrExport: string;
    importOrExportType: string;
    importOrExportTypeName: string
    portCode: string;
    billOfEntryDate: string;
    billOfEntryNo: string;
    claimRefund: string;

}
export class TaxExtensionModel implements ITaxExtensionModel {
    @AutoMap() docEntry!: number;
    @AutoMap() importOrExport: string = "";
    @AutoMap() importOrExportType: string = "";
    @AutoMap() importOrExportTypeName: string = ""
    @AutoMap() portCode: string = "";
    @AutoMap() billOfEntryDate: string = "";
    @AutoMap() billOfEntryNo: string = "";
    @AutoMap() claimRefund: string = "";
    constructor() {
        createMap(mapper, TaxExtensionModel, TaxExtensionModelSAP,
            // forMember(
            //     (destination) => destination.DocEntry,
            //     mapFrom((source) => source.docEntry)
            // ),
            forMember(
                (destination) => destination.ImportOrExport,
                mapFrom((source) => source.importOrExport == "" ? "N" : "Y")
            ),
            forMember(
                (destination) => destination.ImportOrExportType,
                mapFrom((source) => source.importOrExportType)
            ),
            forMember(
                (destination) => destination.PortCode,
                mapFrom((source) => source.portCode)
            ),
            forMember(
                (destination) => destination.BillOfEntryDate,
                mapFrom((source) => source.billOfEntryDate)
            ),
            forMember(
                (destination) => destination.BillOfEntryNo,
                mapFrom((source) => source.billOfEntryNo)
            ),
            forMember(
                (destination) => destination.ClaimRefund,
                mapFrom((source) => source.claimRefund)
            )
        );
    }
}

export interface ITaxExtensionModelSAP {
    // DocEntry: number;
    ImportOrExport: string;
    ImportOrExportType: string;
    //  ImportOrExportTypeName:string
    PortCode: string;
    BillOfEntryDate: string;
    BillOfEntryNo: string;
    ClaimRefund: string;
}

export class TaxExtensionModelSAP implements ITaxExtensionModelSAP {
    //  @AutoMap() DocEntry!: number;
    @AutoMap() ImportOrExport: string = "";
    @AutoMap() ImportOrExportType: string = "";
    // @AutoMap() ImportOrExportTypeName:string=""
    @AutoMap() PortCode: string = "";
    @AutoMap() BillOfEntryDate: string = "";
    @AutoMap() BillOfEntryNo: string = "";
    @AutoMap() ClaimRefund: string = "";
    constructor() {
        createMap(mapper, TaxExtensionModel, TaxExtensionModelSAP,
            // forMember(
            //     (destination) => destination.DocEntry,
            //     mapFrom((source) => source.docEntry)
            // ),
            forMember(
                (destination) => destination.ImportOrExport,
                mapFrom((source) => source.importOrExport == "" ? "N" : "Y")
            ),
            forMember(
                (destination) => destination.ImportOrExportType,
                mapFrom((source) => source.importOrExportType)
            ),
            forMember(
                (destination) => destination.PortCode,
                mapFrom((source) => source.portCode)
            ),
            forMember(
                (destination) => destination.BillOfEntryDate,
                mapFrom((source) => source.billOfEntryDate)
            ),
            forMember(
                (destination) => destination.BillOfEntryNo,
                mapFrom((source) => source.billOfEntryNo)
            ),
            forMember(
                (destination) => destination.ClaimRefund,
                mapFrom((source) => source.claimRefund)
            )
        );
    }
}

// export interface IPickListsModel {
//     name:string,
// ownerCode: number ,
// ownerName: string,
// pickDate: string,
// remarks: string ,
// status: string ,
// objectType: string,
// useBaseUnits: string 
// pickListsLines :PickListsLinesModel[]=[]
// }
// export class  PickListsModel{
//  @AutoMap()   name:string ="",
//  @AutoMap()   ownerCode: number =0,
//  @AutoMap()   ownerName: string="",
//  @AutoMap()   pickDate: string="",
//  @AutoMap()   remarks: string ="",
//  @AutoMap()   status: string ="",
//  @AutoMap()   objectType: string ="",
//  @AutoMap()   useBaseUnits: string =""
//  @AutoMap()   pickListsLines :PickListsLinesModel[]=[] 
// }
/////////////////////////////End////////////////////////

export class EwayBillDetails {
    SupplyType: string = '';
    SubType: number | null = null;
    DocumentType: string = '';
    TransactionType: string | number = '';
    MainHSNEntry: null | number = null;
    EWayBillNo: string = '';
    EWayBillDate: null | Date = null;
    EWayBillExpirationDate: null | Date = null;
    TransporterID: string = '';
    TransporterName: string = '';
    TransporterDocNo: string = '';
    TransporterDocDate: null = null;
    TransportationMode: null | number = null;
    Distance: number | null = null;
    VehicleType: string = '';
    VehicleNo: string = '';
    TransporterEntry: null | number = null;
    TransporterLineNumber: null = null;
    BillFromName: string = "";
    BillFromGSTIN: string = "";
    BillFromStateGSTCode: string = "";
    DispatchFromAddress1: string = "";
    DispatchFromAddress2: string = "";
    DispatchFromZipCode: string = "";
    DispatchFromStateGSTCode: string = "";
    BillToName: string = "";
    BillToGSTIN: string = "";
    BillToStateGSTCode: string = "";
    ShipToAddress1: string = "";
    ShipToAddress2: string = "";
    ShipToZipCode: string = "";
    ShipToStateGSTCode: string = "";
    DispatchFromPlace: string = "";
    ShipToPlace: string = "";

    U_UTL_CARES: string = "";
    U_UTL_ST_CANRMK: string = "";
    U_UTL_ST_UPRESR: string = "";
    U_UTL_ST_URMK: string = "";
    U_UTL_ST_EWayUpDt: string = "";
    U_UTL_ST_EWBSts: string = "";
}
export class ElectronicProtocol {
    ProtocolCode: string = ''
    GenerationType: string = ''
    MappingID: number = 0
}
export interface IMarketingDocument extends BaseModel {
    selected: boolean;
    absoluteentry: number;
    downPaymentType?: string;

    department: string;
    departmentName: string;
    requester: string;
    reqTypeName: string;
    reqType: number;
    email: string;
    requesterName: string;
    docEntry: number;
    docNum: number;
    docType: string;
    docDate: string | Date;
    documentStatus: string;
    objType: string
    docDueDate: string | Date;
    cardCode: string;
    cardName: string;
    address: string;
    numAtCard: string;
    vatSum: number;
    discountPercent: number;
    totalDiscount: number;
    docRate: number;
    docTotal?: number;
    docCurrency: string;
    docCurrencyName: string;
    comments: string;
    paymentGroupCode: number;
    paymentGroupCodeName: string;
    salesPersonCode: number;
    shipPlace: number;
    shipPlaceName: number;
    salesPersonCodeName: string;
    contactPersonCode: number;
    contactPersonCodeName: string;
    series?: number;
    seriesName: string;
    taxDate: string | Date;
    originalRefDate: string | Date;
    originalRefNo: string;
    totalExpns: number;
    address2: string;
    shipToCode: string;
    payToCode: string;
    wtAmount: number;
    project: string;
    projectName: string;
    baseAmount: number;
    bpL_IDAssignedToInvoice: number;
    branchName: string;
    rounding: string;
    roundingDiffAmount: number;
    totalBeforeDiscount: number;
    placeOfSupplyCode: string;
    placeOfSupplyCodeName: string;
    documentStatusName: string;
    attachmentEntry: string | null;
    documentLines: IDocumentLinesModel[];
    documentAdditionalExpenses: IDocumentAdditionalExpensesModel[];
    taxExtension: ITaxExtensionModel | any
    enumData: IAllEnumData;
    requriedDate: string | Date;
    Attachments2_Lines: IAttachments2_LinesModel[];
    eWayBillDetails: EwayBillDetails;
    electronicProtocols: Array<ElectronicProtocol>;
    vatRegNum: string | null;
    measureUnit: string | null;
    uomName: string | null;
    //for pick list 
    name: string;
    ownerCode: number;
    ownerName: string;
    pickDate: string;
    remarks: string;
    status: string;
    objectType: string;
    useBaseUnits: string;
    pickListsLines: PickListsLinesModel[];
    seqCode: number;
    seqName: string | null;
    nextNum: number;
    serial?: number;

    U_UTL_CARES: string;
    U_UTL_ST_CANRMK: string;
    U_UTL_ST_UPRESR: string;
    U_UTL_ST_URMK: string;
    U_UTL_ST_EWayUpDt: string;
    U_UTL_ST_EWBSts: string;
    gstTranTypName: string;
    gstTranTyp: string;   //add new field for SalesInvoice,CreditNotes,PurchaseInvoice,DebitNote suggest by Sourav verma

    u_TIBIDNO: string;
    u_TICNTPRSN: string;
    u_TICNTCTNO: string
    u_TIBuyDt: string | Date
    u_TIBuyRef: string;
    u_TIShipDt: string | Date;
    u_TICANORREV: string;
    u_TIShipTo: string
    u_TIShipAdr: string;
    u_TICLAIMNO: string;
    u_TIDEBTYPE: string;
    u_ORDTYPE: string;
    u_SONUM: string;
    u_SODATE: string | Date;
    u_SN: string;
    u_PriceListFlag: string;
    u_TI_PriceDiff: number;
    u_TIDckNo: string;
    U_B1User: string;
}



// ============================================================================
// =============================== CLASSES ====================================
// ============================================================================
export class MarketingDocument implements IMarketingDocument {
    @AutoMap() selected: boolean = false;
    @AutoMap() absoluteentry: number = 0;

    @AutoMap() reqType: number = 12;
    @AutoMap() downPaymentType?: string = "dptRequest";
    @AutoMap() department: string = "";
    @AutoMap() departmentName: string = "";
    @AutoMap() gstTranTyp = "";
    @AutoMap() gstTranTypName = "";
    @AutoMap() reqTypeName: string = "";
    @AutoMap() email: string = "";
    @AutoMap() requester: string = "";
    @AutoMap() requesterName: string = "";
    @AutoMap() requriedDate: string | Date = "";
    @AutoMap() docEntry!: number;
    @AutoMap() docNum!: number;
    @AutoMap() docType: string = "";
    @AutoMap() docDate: string | Date = "";
    @AutoMap() documentStatus: string = "";
    @AutoMap() objType: string = "";
    @AutoMap() docDueDate: string | Date = "";
    @AutoMap() cardCode: string = "";
    @AutoMap() cardName: string = "";
    @AutoMap() address: string = "";
    @AutoMap() numAtCard: string = "";
    @AutoMap() vatSum!: number;
    @AutoMap() discountPercent!: number;
    @AutoMap() totalDiscount!: number;
    @AutoMap() docRate!: number;
    @AutoMap() docTotal!: number;
    @AutoMap() docCurrency: string = "";
    @AutoMap() docCurrencyName: string = "";
    @AutoMap() comments: string = "";
    @AutoMap() paymentGroupCode!: number;
    @AutoMap() paymentGroupCodeName: string = "";
    @AutoMap() salesPersonCode!: number;
    @AutoMap() shipPlace!: number;
    @AutoMap() shipPlaceName!: number;
    @AutoMap() salesPersonCodeName: string = "";
    @AutoMap() contactPersonCode!: number;
    @AutoMap() contactPersonCodeName: string = "";
    @AutoMap() series: number = 70;
    @AutoMap() seriesName: string = "Primary";
    @AutoMap() taxDate: string | Date = "";
    @AutoMap() originalRefDate: string | Date = "";
    @AutoMap() originalRefNo: string = "";
    @AutoMap() totalExpns!: number;
    @AutoMap() address2: string = "";
    @AutoMap() shipToCode: string = "";
    @AutoMap() payToCode: string = "";
    @AutoMap() wtAmount!: number;
    @AutoMap() project: string = "";
    @AutoMap() projectName: string = "";
    @AutoMap() baseAmount!: number;
    @AutoMap() bpL_IDAssignedToInvoice!: number;
    @AutoMap() branchName: any = "";
    @AutoMap() rounding: string = "";
    @AutoMap() roundingDiffAmount!: number;
    @AutoMap() totalBeforeDiscount!: number;
    @AutoMap() placeOfSupplyCode: string = "";
    @AutoMap() placeOfSupplyCodeName: string = "";
    @AutoMap() documentStatusName: string = "";
    @AutoMap() attachmentEntry: string | null = null;
    @AutoMap(() => DocumentLinesModel)
    @AutoMap(() => DocumentAdditionalExpensesModel)
    @AutoMap(() => TaxExtensionModel)
    documentLines: DocumentLinesModel[] = [];
    documentAdditionalExpenses: IDocumentAdditionalExpensesModel[] = [];
    taxExtension: ITaxExtensionModel = new TaxExtensionModel()
    @AutoMap() enumData: IAllEnumData = new AllEnumdata();
    @AutoMap(() => Attachments2_LinesModel)
    Attachments2_Lines: Attachments2_LinesModel[] = [];
    @AutoMap() eWayBillDetails: EwayBillDetails = new EwayBillDetails();
    @AutoMap() electronicProtocols: Array<ElectronicProtocol> = new Array();
    @AutoMap() vatRegNum: string = "";
    @AutoMap() measureUnit: string = "";
    @AutoMap() uomName: string = "";

    // for Pick list
    @AutoMap() name: string = "";
    @AutoMap() ownerCode: number = 0;
    @AutoMap() ownerName: string = "";
    @AutoMap() pickDate: string = "";
    @AutoMap() remarks: string = "";
    @AutoMap() status: string = "";
    @AutoMap() objectType: string = "";
    @AutoMap() useBaseUnits: string = "";
    @AutoMap() pickListsLines: PickListsLinesModel[] = []
    @AutoMap() seqCode: number = 0;
    @AutoMap() seqName: string = "";
    @AutoMap() nextNum: number = 0;
    @AutoMap() serial?: number;

    @AutoMap() U_UTL_CARES: string = "";
    @AutoMap() U_UTL_ST_CANRMK: string = "";
    @AutoMap() U_UTL_ST_UPRESR: string = "";
    @AutoMap() U_UTL_ST_URMK: string = "";
    @AutoMap() U_UTL_ST_EWayUpDt: string = "";
    @AutoMap() U_UTL_ST_EWBSts: string = "";
    @AutoMap() U_B1User: string = '';

    @AutoMap() u_TIBIDNO: string = "";
    @AutoMap() u_TICNTPRSN: string = "";
    @AutoMap() u_TICNTCTNO: string = ""
    @AutoMap() u_TIBuyDt: string | Date = "";
    @AutoMap() u_TIBuyRef: string = "";
    @AutoMap() u_TIShipDt: string | Date = "";
    @AutoMap() u_TICANORREV: string = "";
    @AutoMap() u_TIShipTo: string = ""
    @AutoMap() u_TIShipAdr: string = "";
    @AutoMap() u_TICLAIMNO: string = "";
    @AutoMap() u_TIDEBTYPE: string = "N";
    @AutoMap() u_ORDTYPE: string = "";
    @AutoMap() u_SONUM: string = "";
    @AutoMap() u_SODATE: string | Date = "";
    @AutoMap() u_SN: string = "";
    @AutoMap() u_PriceListFlag: string = '';
    @AutoMap() u_TI_PriceDiff: number = 0;
    @AutoMap() u_TIDckNo: string = "";

}




export interface IMarketingDocumentSAP {
    RequriedDate?: string | null,
    Department: string;

    DownPaymentType?: string;
    DepartmentName: string;
    Requester: string;
    ReqType: number;
    Email: string;
    ReqTypeName: string;
    RequesterName: string;
    requriedDate?: string,
    DocEntry?: number;
    DocNum?: number;
    DocType?: string;
    DocDate?: string | null;
    DocumentStatus?: string;
    ObjType?: string
    DocDueDate?: string | null;
    CardCode?: string;
    CardName: string;
    Address?: string;
    NumAtCard?: string;
    VatSum?: number;
    DiscountPercent?: number;
    TotalDiscount?: number;
    DocRate?: number;
    DocTotal?: number;
    DocCurrency?: string;
    //  DocCurrencyName: string;
    Comments?: string;
    PaymentGroupCode?: number;
    PaymentGroupCodeName?: string;
    SalesPersonCode?: number;
    ShipPlace?: number;
    // SalesPersonCodeName: string;
    ContactPersonCode?: number;
    // ContactPersonCodeName: string;
    Series?: number;
    // SeriesName: string;
    TaxDate?: string | null;
    OriginalRefDate: string | null;
    OriginalRefNo: string;
    TotalExpns?: number;
    Address2?: string;
    // ShipToCode: string;
    //  PayToCode: string;
    WtAmount?: number;
    Project?: string;
    // ProjectName: string;
    BaseAmount?: number;
    BPL_IDAssignedToInvoice?: number;
    //  BplName: string;
    Rounding?: string;
    RoundingDiffAmount?: number;
    TotalBeforeDiscount?: number;
    PlaceOfSupply?: string;
    PlaceOfSupplyCode?: string;
    //  PlaceOfSupplyCodeName: string;
    AttachmentEntry?: string | null;
    DocumentLines?: IDocumentLinesModelSAP[] | any;
    DocumentAdditionalExpenses?: IDocumentAdditionalExpensesModelSAP[];
    TaxExtension?: ITaxExtensionModelSAP,
    EWayBillDetails: EwayBillDetails;
    ElectronicProtocols: Array<ElectronicProtocol>;

    VatRegNum?: string;
    MeasureUnit: string;
    UomName: string
    //  AbsoluteEntry:number;
    Name?: string
    OwnerCode?: number
    OwnerName?: string
    PickDate?: string
    Remarks?: string
    Status?: string
    ObjectType?: string
    UseBaseUnits?: string
    PickListsLines?: PickListsLinesModelSAP[]
    ShipToCode: string | null;
    SeqCode: number;
    SeqName: string | null;
    NextNum: number;

    U_UTL_CARES: string;
    U_UTL_ST_CANRMK: string;
    U_UTL_ST_UPRESR: string;
    U_UTL_ST_URMK: string;
    U_UTL_ST_EWayUpDt: string;
    U_UTL_ST_EWBSts: string;
    U_B1User: string
    U_TIBuyDt: string | null;
    U_TIShipDt: string | null;
    U_TICANORREV: string;
    U_TIShipTo: string
    U_TIShipAdr: string;
    U_TICLAIMNO: string;
    U_TIDEBTYPE: string;
    U_ORDTYPE: string;
    U_SONUM: string;
    U_SODATE: string | null;
    U_SN: string;
    U_PriceListFlag: string;
    U_TI_PriceDiff: number;
    U_TIDckNo: string
}



// ============================================================================
// ============================= SAP CLASSES ==================================
// ============================================================================
export class MarketingDocumentSAP implements IMarketingDocumentSAP {
    @AutoMap() RequriedDate?: string | null = null;
    @AutoMap() ReqType: number = 12;
    // @AutoMap() AbsoluteEntry: number=0;
    @AutoMap() DownPaymentType?: string = "dptRequest";
    @AutoMap() Department: string = "";
    @AutoMap() DepartmentName: string = "";
    @AutoMap() ReqTypeName: string = "";
    @AutoMap() Email: string = "";
    @AutoMap() Requester: string = "";
    @AutoMap() RequesterName: string = "";
    @AutoMap() requriedDate?: string = "";
    @AutoMap() DocEntry?: number;
    @AutoMap() DocNum?: number;
    @AutoMap() DocType?: string = "";
    @AutoMap() DocDate?: string | null = null;
    @AutoMap() DocumentStatus?: string = "";
    @AutoMap() ObjType?: string = "";
    @AutoMap() DocDueDate?: string | null = null;
    @AutoMap() CardCode?: string = "";
    @AutoMap() CardName: string = "";
    @AutoMap() Address?: string = "";
    @AutoMap() NumAtCard?: string = "";
    @AutoMap() VatSum?: number;
    @AutoMap() DiscountPercent?: number;
    @AutoMap() TotalDiscount?: number;
    @AutoMap() DocRate?: number;
    @AutoMap() DocTotal?: number;
    @AutoMap() DocCurrency?: string = "";
    // @AutoMap() DocCurrencyName: string = "";
    @AutoMap() Comments?: string = "";
    @AutoMap() PaymentGroupCode?: number;
    @AutoMap() PaymentGroupCodeName?: string = "";
    @AutoMap() SalesPersonCode?: number;
    @AutoMap() ShipPlace?: number;
    //  @AutoMap() SalesPersonCodeName: string = "";
    @AutoMap() ContactPersonCode?: number;
    //  @AutoMap() ContactPersonCodeName: string = "";
    @AutoMap() Series?: number;
    //  @AutoMap() SeriesName: string = "";
    @AutoMap() TaxDate?: string | null = null;
    @AutoMap() OriginalRefDate: string | null = "";
    @AutoMap() OriginalRefNo: string = "";
    @AutoMap() TotalExpns?: number;
    @AutoMap() Address2?: string = "";
    // @AutoMap() ShipToCode: string = "";
    // @AutoMap() PayToCode: string = "";
    @AutoMap() WtAmount?: number;
    @AutoMap() Project?: string = "";
    //  @AutoMap() ProjectName: string = "";
    @AutoMap() BaseAmount?: number;
    @AutoMap() BPL_IDAssignedToInvoice?: number;
    //   @AutoMap() BplName: string = "";
    @AutoMap() VatRegNum: string = "";
    @AutoMap() MeasureUnit: string = "";
    @AutoMap() UomName: string = "";
    @AutoMap() Rounding?: string = "";
    @AutoMap() RoundingDiffAmount?: number;
    @AutoMap() TotalBeforeDiscount?: number;
    @AutoMap() PlaceOfSupply?: string = "";
    @AutoMap() PlaceOfSupplyCode?: string = "";
    //  @AutoMap() PlaceOfSupplyCodeName: string = "";
    @AutoMap() AttachmentEntry?: string | null = null;
    @AutoMap(() => DocumentLinesModelSAP) DocumentLines?: DocumentLinesModelSAP[] = [];
    @AutoMap(() => DocumentAdditionalExpensesModelSAP) DocumentAdditionalExpenses?: DocumentAdditionalExpensesModelSAP[] = [];
    @AutoMap(() => TaxExtensionModelSAP) TaxExtension?: TaxExtensionModelSAP = new TaxExtensionModelSAP()
    @AutoMap() EWayBillDetails: EwayBillDetails = new EwayBillDetails();
    @AutoMap() ElectronicProtocols: Array<ElectronicProtocol> = new Array();
    @AutoMap() Name?: string = "UTL1928";
    @AutoMap() OwnerCode?: number = 8;
    @AutoMap() OwnerName?: string = "";
    @AutoMap() PickDate?: string = "";
    @AutoMap() Remarks?: string = "";
    @AutoMap() Status?: string = "ps_Released";
    @AutoMap() ObjectType?: string = "";
    @AutoMap() UseBaseUnits?: string = "tNO";
    @AutoMap() PickListsLines?: PickListsLinesModelSAP[] = [];
    @AutoMap() ShipToCode: string = "";
    @AutoMap() SeqCode: number = 0;
    @AutoMap() SeqName: string = "";
    @AutoMap() NextNum: number = 0;

    @AutoMap() U_UTL_CARES: string = "";
    @AutoMap() U_UTL_ST_CANRMK: string = "";
    @AutoMap() U_UTL_ST_UPRESR: string = "";
    @AutoMap() U_UTL_ST_URMK: string = "";
    @AutoMap() U_UTL_ST_EWayUpDt: string = "";
    @AutoMap() U_UTL_ST_EWBSts: string = "";

    @AutoMap() U_TIBIDNO: string = "";

    @AutoMap() U_B1User: string = ''
    @AutoMap() U_TICNTPRSN: string = "";
    @AutoMap() U_TICNTCTNO: string = ""
    @AutoMap() U_TIBuyDt: string | null = null;
    @AutoMap() U_TIBuyRef: string = "";
    @AutoMap() U_TIShipDt: string | null = null;
    @AutoMap() U_TICANORREV: string = "";
    @AutoMap() U_TIShipTo: string = ""
    @AutoMap() U_TIShipAdr: string = "";
    @AutoMap() U_TICLAIMNO: string = "";
    @AutoMap() U_TIDEBTYPE: string = "N";
    @AutoMap() U_ORDTYPE: string = "";
    @AutoMap() U_SONUM: string = "";
    @AutoMap() U_SODATE: string | null = null;
    @AutoMap() U_SN: string = "";
    @AutoMap() U_PriceListFlag: string = '';
    @AutoMap() U_TI_PriceDiff: number = 0;
    @AutoMap() U_TIDckNo: string = "";


    constructor() {
        createMap(mapper, MarketingDocument, MarketingDocumentSAP,
            forMember(
                (destination) => destination.DocEntry,
                mapFrom((source) => source.docEntry)
            ),

            forMember(
                (destination) => destination.DownPaymentType,
                mapFrom((source) => source.downPaymentType)
            ),
            forMember(
                (destination) => destination.ReqType,
                mapFrom((source) => source.reqType)
            ),
            forMember(
                (destination) => destination.Email,
                mapFrom((source) => source.email)
            ),
            forMember(
                (destination) => destination.Department,
                mapFrom((source) => source.department)
            ),
            forMember(
                (destination) => destination.DepartmentName,
                mapFrom((source) => source.departmentName)
            ),
            forMember(
                (destination) => destination.ReqTypeName,
                mapFrom((source) => source.reqTypeName)
            ),
            forMember(
                (destination) => destination.Requester,
                mapFrom((source) => source.requester)
            ),
            forMember(
                (destination) => destination.RequesterName,
                mapFrom((source) => source.requesterName)
            ),
            forMember(
                (destination) => destination.DocNum,
                mapFrom((source) => source.docNum)
            ),
            forMember(
                (destination) => destination.DocType,
                mapFrom((source) => source.docType)
            ),
            forMember(
                (destination) => destination.DocumentStatus,
                mapFrom((source) => source.documentStatus)
            ),
            forMember(
                (destination) => destination.ObjType,
                mapFrom((source) => source.objType)
            ),
            forMember(
                (destination) => destination.DocDate,
                mapFrom((source) => source.docDate)
            ),
            forMember(
                (destination) => destination.DocDueDate,
                mapFrom((source) => source.docDueDate)
            ),
            forMember(
                (destination) => destination.CardCode,
                mapFrom((source) => source.cardCode)
            ),

            forMember(
                (destination) => destination.CardName,
                mapFrom((source) => source.cardName)
            ),
            forMember(
                (destination) => destination.Address,
                mapFrom((source) => source.address)
            ),

            forMember(
                (destination) => destination.NumAtCard,
                mapFrom((source) => source.numAtCard)
            ),
            forMember(
                (destination) => destination.VatSum,
                mapFrom((source) => source.vatSum)
            ),
            forMember(
                (destination) => destination.DiscountPercent,
                mapFrom((source) => source.discountPercent)
            ),
            forMember(
                (destination) => destination.AttachmentEntry,
                mapFrom((source) => source.attachmentEntry)
            ),
            forMember(
                (destination) => destination.DocRate,
                mapFrom((source) => source.docRate)
            ),
            forMember(
                (destination) => destination.DocTotal,
                mapFrom((source) => source.docTotal)
            ),
            forMember(
                (destination) => destination.DocCurrency,
                mapFrom((source) => source.docCurrency)
            ),
            // forMember(
            //     (destination) => destination.DocCurrencyName,
            //     mapFrom((source) => source.docCurrencyName)
            // ),
            forMember(
                (destination) => destination.Comments,
                mapFrom((source) => source.comments)
            ),
            forMember(
                (destination) => destination.PaymentGroupCode,
                mapFrom((source) => source.paymentGroupCode)
            ),
            forMember(
                (destination) => destination.PaymentGroupCodeName,
                mapFrom((source) => source.paymentGroupCodeName)
            ),
            forMember(
                (destination) => destination.SalesPersonCode,
                mapFrom((source) => source.salesPersonCode)
            ),
            forMember(
                (destination) => destination.ShipPlace,
                mapFrom((source) => source.shipPlace)
            ),
            // forMember(
            //     (destination) => destination.SalesPersonCodeName,
            //     mapFrom((source) => source.salesPersonCodeName)
            // ),
            forMember(
                (destination) => destination.ContactPersonCode,
                mapFrom((source) => source.contactPersonCode)
            ),
            // forMember(
            //     (destination) => destination.ContactPersonCodeName,
            //     mapFrom((source) => source.contactPersonCodeName)
            // ),
            forMember(
                (destination) => destination.Series,
                mapFrom((source) => source.series)
            ),
            // forMember(
            //     (destination) => destination.SeriesName,
            //     mapFrom((source) => source.seriesName)
            // ),
            forMember(
                (destination) => destination.TaxDate,
                mapFrom((source) => source.taxDate)
            ),
            forMember(
                (destination) => destination.OriginalRefDate,
                mapFrom((source) => source.originalRefDate)
            ),
            forMember(
                (destination) => destination.OriginalRefNo,
                mapFrom((source) => source.originalRefNo)
            ),
            forMember(
                (destination) => destination.TotalExpns,
                mapFrom((source) => source.totalExpns)
            ),
            forMember(
                (destination) => destination.Address2,
                mapFrom((source) => source.address2)
            ),
            // forMember(
            //     (destination) => destination.ShipToCode,
            //     mapFrom((source) => source.shipToCode)
            // ),
            // forMember(
            //     (destination) => destination.PayToCode,
            //     mapFrom((source) => source.payToCode)
            // ),
            forMember(
                (destination) => destination.WtAmount,
                mapFrom((source) => source.wtAmount)
            ),
            forMember(
                (destination) => destination.Project,
                mapFrom((source) => source.project)
            ),
            // forMember(
            //     (destination) => destination.ProjectName,
            //     mapFrom((source) => source.projectName)
            // ),
            forMember(
                (destination) => destination.BaseAmount,
                mapFrom((source) => source.baseAmount)
            ),
            forMember(
                (destination) => destination.BPL_IDAssignedToInvoice,
                mapFrom((source) => source.bpL_IDAssignedToInvoice)
            ),
            // forMember(
            //     (destination) => destination.BplName,
            //     mapFrom((source) => source.branchName)
            // ),
            forMember(
                (destination) => destination.VatRegNum,
                mapFrom((source) => source.vatRegNum)
            ),
            forMember(
                (destination) => destination.UomName,
                mapFrom((source) => source.uomName)
            ),
            forMember(
                (destination) => destination.MeasureUnit,
                mapFrom((source) => source.measureUnit)
            ),
            forMember(
                (destination) => destination.Rounding,
                mapFrom((source) => source.rounding)
            ),
            forMember(
                (destination) => destination.RoundingDiffAmount,
                mapFrom((source) => source.roundingDiffAmount)
            ),
            forMember(
                (destination) => destination.TotalBeforeDiscount,
                mapFrom((source) => source.totalBeforeDiscount)
            ),
            forMember(
                (destination) => destination.PlaceOfSupplyCode,
                mapFrom((source) => source.placeOfSupplyCode)
            ),
            // forMember(
            //     (destination) => destination.PlaceOfSupplyCodeName,
            //     mapFrom((source) => source.placeOfSupplyCodeName)
            // ),
            forMember(
                (destination) => destination.DocumentLines,
                mapWith(DocumentLinesModelSAP, DocumentLinesModel, (source) => source.documentLines)
            ),
            forMember(
                (destination) => destination.PickListsLines,
                mapWith(PickListsLinesModelSAP, PickListsLinesModel, (source) => source.pickListsLines)
            ),
            forMember(
                (destination) => destination.DocumentAdditionalExpenses,
                mapWith(DocumentAdditionalExpensesModelSAP, DocumentAdditionalExpensesModel, (source) => source.documentAdditionalExpenses)
            ),
            forMember(
                (destination) => destination.TaxExtension,
                mapWith(TaxExtensionModelSAP, TaxExtensionModel, (source) => source.taxExtension)
            ),
            forMember(
                (destination) => destination.RequriedDate,
                mapFrom((source) => source.requriedDate)
            ),
            forMember(
                (destination) => destination.PickDate,
                mapFrom((source) => source.pickDate)
            ),
            forMember(
                (destination) => destination.EWayBillDetails,
                mapFrom((source) => source.eWayBillDetails)
            ),
            forMember(
                (destination) => destination.ElectronicProtocols,
                mapFrom((source) => source.electronicProtocols),
            ), forMember(
                (destination) => destination.ShipToCode,
                mapFrom((source) => source.shipToCode),
            ),
            forMember(
                (destination) => destination.SeqCode,
                mapFrom((source) => source.seqCode),
            ),
            forMember(
                (destination) => destination.SeqName,
                mapFrom((source) => source.seqName),
            ),
            forMember(
                (destination) => destination.NextNum,
                mapFrom((source) => source.nextNum),
            ),
            forMember(
                (destination) => destination.U_UTL_CARES,
                mapFrom((source) => source.U_UTL_CARES),
            ),
            forMember(
                (destination) => destination.U_UTL_ST_CANRMK,
                mapFrom((source) => source.U_UTL_ST_CANRMK),
            ),
            forMember(
                (destination) => destination.U_UTL_ST_EWBSts,
                mapFrom((source) => source.U_UTL_ST_EWBSts),
            ),
            forMember(
                (destination) => destination.U_UTL_ST_EWayUpDt,
                mapFrom((source) => source.U_UTL_ST_EWayUpDt),
            ),
            forMember(
                (destination) => destination.U_B1User,
                mapFrom((source) => source.U_B1User),
            ),
            forMember(
                (destination) => destination.U_UTL_ST_UPRESR,
                mapFrom((source) => source.U_UTL_ST_UPRESR),
            ),
            forMember(
                (destination) => destination.U_UTL_ST_URMK,
                mapFrom((source) => source.U_UTL_ST_URMK),
            ),
            forMember(
                (destination) => destination.U_TIBIDNO,
                mapFrom((source) => source.u_TIBIDNO),
            ),
            forMember(
                (destination) => destination.U_TICNTPRSN,
                mapFrom((source) => source.u_TICNTPRSN),
            ),
            forMember(
                (destination) => destination.U_TICNTCTNO,
                mapFrom((source) => source.u_TICNTCTNO),
            ),
            forMember(
                (destination) => destination.U_TIBuyDt,
                mapFrom((source) => source.u_TIBuyDt),
            ),
            forMember(
                (destination) => destination.U_TIBuyRef,
                mapFrom((source) => source.u_TIBuyRef),
            ),
            forMember(
                (destination) => destination.U_TIShipDt,
                mapFrom((source) => source.u_TIShipDt),
            ),
            forMember(
                (destination) => destination.U_TICANORREV,
                mapFrom((source) => source.u_TICANORREV),
            ),
            forMember(
                (destination) => destination.U_TIShipTo,
                mapFrom((source) => source.u_TIShipTo),
            ),
            forMember(
                (destination) => destination.U_TIShipAdr,
                mapFrom((source) => source.u_TIShipAdr),
            ),
            forMember(
                (destination) => destination.U_TICLAIMNO,
                mapFrom((source) => source.u_TICLAIMNO),
            ),
            forMember(
                (destination) => destination.U_TIDEBTYPE,
                mapFrom((source) => source.u_TIDEBTYPE),
            ),
            forMember(
                (destination) => destination.U_ORDTYPE,
                mapFrom((source) => source.u_ORDTYPE),
            ),
            forMember(
                (destination) => destination.U_SONUM,
                mapFrom((source) => source.u_SONUM),
            ),
            forMember(
                (destination) => destination.U_SODATE,
                mapFrom((source) => source.u_SODATE),
            ),
            forMember(
                (destination) => destination.U_SN,
                mapFrom((source) => source.u_SN),
            ),
            forMember(
                (destination) => destination.U_PriceListFlag,
                mapFrom((source) => source.u_PriceListFlag),
            ),
            forMember(
                (destination) => destination.U_TI_PriceDiff,
                mapFrom((source) => source.u_TI_PriceDiff),
            ),
            forMember(
                (destination) => destination.U_TIDckNo,
                mapFrom((source) => source.u_TIDckNo),
            ),
        );

    }

}
export class PickListsLinesModel {
    @AutoMap() orderEntry: number = 0;
    @AutoMap() orderRowID: number = 0;
    @AutoMap() pickedQuantity: number = 0;
    @AutoMap() pickStatus: string = "";
    @AutoMap() releasedQuantity: number = 0;
    @AutoMap() previouslyReleasedQuantity: number = 0;
    @AutoMap() baseObjectType: number = 17;
    @AutoMap() serialNumbers: SerialNumbersModel[] = [];
    @AutoMap() batchNumbers: BatchNumbersModel[] = [];
    @AutoMap() documentLinesBinAllocations: any[] = [];
    @AutoMap() absoluteEntry: number = 0;
    @AutoMap() pickEntry: number = 0;
    @AutoMap() lineNumber: number = 0;
    constructor() {
        createMap(mapper, PickListsLinesModel, PickListsLinesModelSAP,

            forMember(
                (destination) => destination.OrderRowID,
                mapFrom((source) => source.orderRowID)
            ),
            forMember(
                (destination) => destination.LineNumber,
                mapFrom((source) => source.lineNumber)
            ),
            forMember(
                (destination) => destination.AbsoluteEntry,
                mapFrom((source) => source.absoluteEntry)
            ),
            forMember(
                (destination) => destination.PickedQuantity,
                mapFrom((source) => source.pickedQuantity)
            ),
            forMember(
                (destination) => destination.PickStatus,
                mapFrom((source) => source.pickStatus)
            ),
            forMember(
                (destination) => destination.ReleasedQuantity,
                mapFrom((source) => source.releasedQuantity)
            ),
            forMember(
                (destination) => destination.PreviouslyReleasedQuantity,
                mapFrom((source) => source.previouslyReleasedQuantity)
            ), forMember(
                (destination) => destination.BaseObjectType,
                mapFrom((source) => source.baseObjectType)
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            ), forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
            ), forMember(
                (destination) => destination.DocumentLinesBinAllocations,
                mapFrom((source) => source.documentLinesBinAllocations)
            ),
            forMember(
                (destination) => destination.OrderEntry,
                mapFrom((source) => source.orderEntry)
            ),
        );
    }
}

export class PickListsLinesModelSAP {
    @AutoMap() OrderEntry: number = 0;
    @AutoMap() LineNumber: number = 0;
    @AutoMap() OrderRowID: number = 0;
    @AutoMap() PickedQuantity: number = 0;
    @AutoMap() PickStatus: string = "ps_Released";
    @AutoMap() ReleasedQuantity: number = 0;
    @AutoMap() PreviouslyReleasedQuantity: number = 0;
    @AutoMap() BaseObjectType: number = 17;
    @AutoMap() SerialNumbers: SerialNumbersModelSAP[] = [];
    @AutoMap() BatchNumbers: BatchNumbersModelSAP[] = [];
    @AutoMap() DocumentLinesBinAllocations: any[] = [];
    @AutoMap() AbsoluteEntry: number = 0;
    //  @AutoMap() PickEntry:number=0;

    constructor() {
        createMap(mapper, PickListsLinesModel, PickListsLinesModelSAP,

            forMember(
                (destination) => destination.OrderRowID,
                mapFrom((source) => source.orderRowID)
            ),
            forMember(
                (destination) => destination.LineNumber,
                mapFrom((source) => source.lineNumber)
            ),
            forMember(
                (destination) => destination.AbsoluteEntry,
                mapFrom((source) => source.absoluteEntry)
            ),
            forMember(
                (destination) => destination.PickedQuantity,
                mapFrom((source) => source.pickedQuantity)
            ),
            forMember(
                (destination) => destination.PickStatus,
                mapFrom((source) => source.pickStatus)
            ),
            forMember(
                (destination) => destination.ReleasedQuantity,
                mapFrom((source) => source.releasedQuantity)
            ),
            forMember(
                (destination) => destination.PreviouslyReleasedQuantity,
                mapFrom((source) => source.previouslyReleasedQuantity)
            ), forMember(
                (destination) => destination.BaseObjectType,
                mapFrom((source) => source.baseObjectType)
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            ), forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
            ),
            forMember(
                (destination) => destination.DocumentLinesBinAllocations,
                mapFrom((source) => source.documentLinesBinAllocations)
            ),
            forMember(
                (destination) => destination.OrderEntry,
                mapFrom((source) => source.orderEntry)
            ),
        );
    }
}

export interface IAllEnumData {
    documentStatus: CommonFilterModel[];
    docType: CommonFilterModel[];
    importOrExportType: CommonFilterModel[];

}

export class AllEnumdata extends CommonEnumData implements IAllEnumData {
    @AutoMap() documentStatus: CommonFilterModel[] = [];
    @AutoMap() docType: CommonFilterModel[] = [];
    @AutoMap() importOrExportType: CommonFilterModel[] = [];




}
export interface IAttachments2_LinesModel {
    AbsoluteEntry: number,
    LineNum: number,
    SourcePath: string
    FileName: string
    FileExtension: string
    AttachmentDate: string
}
export class Attachments2_LinesModel implements IAttachments2_LinesModel {
    AbsoluteEntry!: number
    LineNum!: number
    SourcePath: string = ""
    FileName: string = ""
    FileExtension: string = ""
    AttachmentDate: string = ""
}




